// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draggable {
    position: absolute;
    z-index: 9;
    pointer-events: all;
}

.draggable-handle {
    cursor: grab;
    z-index: 10;
    touch-action: manipulation;
    margin-bottom: 6px;
    display: inline-block;  
    position: absolute;
    left: 3px;
    width: 90%;
    height: 32px;
}

.drag-icon {
    line-height: 32px !important;
    margin:auto;
    display:block;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/utils/draggable.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,aAAa;AACjB","sourcesContent":[".draggable {\n    position: absolute;\n    z-index: 9;\n    pointer-events: all;\n}\n\n.draggable-handle {\n    cursor: grab;\n    z-index: 10;\n    touch-action: manipulation;\n    margin-bottom: 6px;\n    display: inline-block;  \n    position: absolute;\n    left: 3px;\n    width: 90%;\n    height: 32px;\n}\n\n.drag-icon {\n    line-height: 32px !important;\n    margin:auto;\n    display:block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
